// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"7e946e0d","660":"cbd62a64","664":"e8cc6036","675":"382f78a6"}[chunkId] + ".chunk.js";
};